module.exports = __webpack_public_path__ + "img/Salon.22f88703.jpg";